import { Injectable, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './current-user.service';

/** SDG 13 (Climate Action) is the product baseline and cannot be deselected. */
export const REQUIRED_SDG_ID = 13;

/** A company may highlight at most this many SDGs. */
export const MAX_SELECTED_SDGS = 3;

/** SDG selection. Purely declarative, unrelated to reduction tips. */
@Injectable({ providedIn: 'root' })
export class CompanySdgsService {
  private http = inject(HttpClient);
  private currentUserService = inject(CurrentUserService);

  selectedSdgs = computed<number[]>(() => {
    const sdgs = this.currentUserService.currentUser()?.company?.selectedSdgs;
    return sdgs?.length ? sdgs : [REQUIRED_SDG_ID];
  });

  updateSdgs(selectedSdgs: number[]): Observable<{ selectedSdgs: number[] }> {
    const companyId = this.currentUserService.currentUser()?.companyId ?? '';
    const previous = this.selectedSdgs();

    this.currentUserService.patchCompany({ selectedSdgs });

    return this.http
      .put<{ selectedSdgs: number[] }>(`${environment.apiUrl}/company/${companyId}/sdgs`, {
        selectedSdgs,
      })
      .pipe(
        tap((result) => this.currentUserService.patchCompany({ selectedSdgs: result.selectedSdgs })),
        catchError((err) => {
          this.currentUserService.patchCompany({ selectedSdgs: previous });
          return throwError(() => err);
        }),
      );
  }
}
